package one.healthium.tutorial.data

import kotlinx.serialization.json.Json
import one.healthium.base.preferences.AppPreferences
import one.healthium.tutorial.domain.TutorialModel
import one.healthium.tutorial.domain.TutorialRepository
import one.healthium.tutorial.domain.TutorialScreenConfig
import one.primehealth.app.BaseAppResourceProvider
import one.primehealth.app.TargetPlatform
import one.primehealth.app.targetPlatform

internal class AppTutorialRepository(
    private val json: Json,
    private val appResourceProvider: BaseAppResourceProvider,
    private val appPreferences: AppPreferences,
) : TutorialRepository {
    override suspend fun getIntro(): TutorialModel.IntroTutorial {
        val bytes = appResourceProvider.readBytes("files/tutorial/tutorial_v1.json")
        val model = json.decodeFromString<TutorialModel.IntroTutorial>(bytes.decodeToString())
        return model.copy(
            screens = model.screens
                .filter { screenConfig ->
                    when (screenConfig) {
                        is TutorialScreenConfig.TutorialTransparencyAccessScreenConfig -> {
                            targetPlatform() == TargetPlatform.iOS && appPreferences.attRequested.not()
                        }

                        is TutorialScreenConfig.TutorialNotificationsAccessScreenConfig -> {
                            appPreferences.notificationPermissionRequested.not()
                        }

                        else -> true
                    }
                }
        )
    }
}
